module.exports = __webpack_public_path__ + "static/media/ind5ru.492912c8.pdf";